// removed by extract-text-webpack-plugin
module.exports = {"questionPackagesWrapper":"_1Pi_Cj4e5I62SfWfOCye_5","title":"_3LJ4_h0OBKPqiWOCTOM03Z","packageWrapper":"_1ff-7POw-StvY0Dg1oDe55","excludingVat":"_1OSDxzX5prOwJEhverncnU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorQuestionsPackages/RealtorQuestionsPackages.scss
// module id = 1732
// module chunks = 0